const MAP = {
  "list-icon-arrow": "angle-right",
  "list-icon-arrow-circle": "circle-right",
  "list-icon-check": "check",
  "list-icon-caret": "caret-right",
  "list-icon-info": "circle-info",
  "list-icon-circle ": "circle",
  "list-icon-plus": "circle-plus",
  "list-icon-uncheck": "circle-xmark"
};
export const getIcon = (icon: string, type: string) => {
  if (!type) return null;
  if (type === "emt-custom-icon") return icon;

  return `far fa-${MAP[type]}`;
};
